import { isCommInProgress } from '../../modules/communication'
import { SEND_INSTRUCTIONS_REQUEST, RESET_PASSWORD_RESOURCE } from './constants'

export const isSendingIntructions = state =>
  isCommInProgress(SEND_INSTRUCTIONS_REQUEST, state)
export const isResettingPassword = state =>
  isCommInProgress(RESET_PASSWORD_RESOURCE, state)



// WEBPACK FOOTER //
// ./src/services/password-reset/selectors.js